<script setup lang="ts">
import type { PaletteColorProp } from '#imports';

interface IProps {
    size?: number;
    color?: PaletteColorProp | string;
    floating?: boolean;
}

const {
    size = 3,
    color = 'var(--cool-gray-400)',
    floating,
} = defineProps<IProps>();
</script>

<template>
    <div class="loader-container" :class="[{ floating }]">
        <div
            class="loading-dot"
            :style="{
                background: color,
                width: `${size}px`,
                height: `${size}px`,
            }"
        />
        <div
            class="loading-dot"
            :style="{
                background: color,
                width: `${size}px`,
                height: `${size}px`,
            }"
        />
        <div
            class="loading-dot"
            :style="{
                background: color,
                width: `${size}px`,
                height: `${size}px`,
            }"
        />
    </div>
</template>

<style scoped lang="scss">
.loader-container {
    display: inline-flex;
    &.floating {
        position: absolute;
    }
}
.loading-dot {
    border-radius: 100%;
    display: inline-block;
    position: relative;
    margin: 4px;
    animation: bounce 0.8s infinite;
}

.loading-dot:first-child {
    animation-delay: 0.26s;
}

.loading-dot:last-child {
    animation-delay: 0.26s;
}
@keyframes bounce {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.333333);
    }

    100% {
        transform: scale(1);
    }
}
</style>
